var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useRef, useReducer, useCallback, useEffect } from 'react';
var Action;
(function (Action) {
    Action[Action["UpdateValue"] = 0] = "UpdateValue";
    Action[Action["ClearValue"] = 1] = "ClearValue";
    Action[Action["Clear"] = 2] = "Clear";
})(Action || (Action = {}));
;
var reducer = function (state, action) {
    var _a, _b;
    switch (action.type) {
        case Action.UpdateValue:
            return __assign(__assign({}, state), (_a = {}, _a[action.key] = action.value, _a));
        case Action.ClearValue:
            return __assign(__assign({}, state), (_b = {}, _b[action.key] = undefined, _b));
        case Action.Clear:
            return {};
        default:
            return state;
    }
};
export function useDictionary(initialState) {
    var mounted = useRef(false);
    var _a = useReducer(reducer, initialState), state = _a[0], dispatch = _a[1];
    useEffect(function () {
        mounted.current = true;
        return function () {
            mounted.current = false;
        };
    }, []);
    var dispatchOnMounted = useCallback(function (action) {
        if (mounted.current)
            dispatch(action);
    }, [mounted]);
    var onUpdateValue = useCallback(function (key, value) {
        dispatchOnMounted({ type: Action.UpdateValue, key: key, value: value });
    }, []);
    var onClearValue = useCallback(function (key) {
        dispatchOnMounted({ type: Action.ClearValue, key: key });
    }, []);
    var onClear = useCallback(function () {
        dispatchOnMounted({ type: Action.Clear });
    }, []);
    return {
        state: state,
        onUpdateValue: onUpdateValue,
        onClearValue: onClearValue,
        onClear: onClear,
    };
}
//# sourceMappingURL=useDictionary.js.map